import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { parsePhoneNumber, getCountryCallingCode } from 'libphonenumber-js'
import PhoneInput from 'components/common/PhoneInput/PhoneInput'
import InputError from "components/common/InputError/InputError"

const PhoneNumber = ({ control, value, error }) => {
  const { t } = useTranslation()
  const required = t('mainReporting:form.mandatory')

  // Handle phone number changes
  const handleChangeNumber = (value, data, onChange, onBlur) => {
    onChange({
      number: value,
      countryCode: data.countryCode,
    })
    onBlur(value)
  }

  return (
    <>
      <Controller
        control={control}
        name="phone"
        rules={{
          required,
          validate: ({ number, countryCode }) => {
            try {
              const countryCallingCode = getCountryCallingCode(countryCode.toUpperCase())
              const codePays = new RegExp(`^${countryCallingCode}`)
              number = number.replace(codePays, '');

              const phoneNumber = parsePhoneNumber(number, countryCode.toUpperCase())

              const country = phoneNumber.country === countryCode.toUpperCase()
              const possible = phoneNumber.isPossible()
              const valid = phoneNumber.isValid()

              return (country && possible && valid) || t('mainReporting:form.phone.errors.invalid')
            } catch {
              return required
            }
          },
        }}
        render={({ field: { onBlur, onChange } }) => (
          <PhoneInput
            localization={'fr'}
            country={'fr'}
            onBlur={onBlur}
            error={error}
            label={t('mainReporting:form.phone.label')}
            onChange={(value, data) => {
              handleChangeNumber(value, data, onChange, onBlur)
            }}
            onlyCountries={[]}
            placeholder={t('mainReporting:form.phone.placeholder')}
            value={value}
          />
        )}
      />
      <InputError error={error} />
    </>
  )
}

export default PhoneNumber
